module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogHeader":"Do you want to send a message?"}}')
  delete Component.options._Ctor
}
